module.exports = __webpack_public_path__ + "media/images/pages/thermo/about-68d464b47c6cae8b60b6b551027b0a17.jpg";